import { useState, FC, useEffect } from 'react'

import { Button, Col, Row, SelectForm, TimePicker } from 'components'
import moment from 'moment'
import { SPACING } from 'utils'
export interface IPeriocidadeComponent {
  setValue?: any
  periodicidade?: string
  control?: any
  errors?: any
  clearErrors?: any
  listOptions?: any[]
  diario?: any
  semanal?: any
  mensal?: any
  acionador?: any
  diasSemana?: any
  jobNuDiasRecorrencia?: string
  jobDiasSemanaRecorrencia?: string
  selectdDays?: string[]
  jobRecorrenciasList?: any[]
  setHasErrorJob?: (_value) => void
  onSubmitPeriodicidade: (_data: any) => void
}
const Diario: FC<IPeriocidadeComponent> = ({
  setValue,
  control,
  setHasErrorJob,
  periodicidade,
  listOptions,
  jobRecorrenciasList
}) => {
  // LISTA HORARIO DO COMPONENTE
  const [listDiario, setListDiario] = useState([
    {
      hrRecorrencia: '',
      id: 0
    }
  ])

  // NOVA LINHA DE HORARIO
  const handleNewItem = () => {
    setListDiario([
      ...listDiario,
      { hrRecorrencia: '', id: listDiario[listDiario.length - 1].id + 1 }
    ])
  }

  // UPDATE DO HORARIO NA LISTA HORARIO
  const handleTimePicker = (time, index) => {
    if (time) {
      const cpyArr = listDiario.slice()
      cpyArr[index].hrRecorrencia = time
      setListDiario(cpyArr)
      setValue('horarios', cpyArr)
    }
  }

  // DELETAR HORARIO ADICIONADO
  const handleDelete = (id: number) => {
    const cpyArr = listDiario.slice()

    setListDiario(cpyArr.filter((hr) => hr.id !== id))

    setValue(
      'horarios',
      cpyArr.filter((hr) => hr.id !== id)
    )
  }

  const handleClean = () => {
    setListDiario([{ hrRecorrencia: null, id: 0 }])
    setValue('horarios', [{ hrRecorrencia: null, id: 0 }])
  }
  const [errorsJobs, setErrorsJobs] = useState({ horarioError: null })

  useEffect(() => {
    if (jobRecorrenciasList.length == 0) {
      setListDiario([
        {
          hrRecorrencia: '',
          id: 0
        }
      ])
    } else {
      setListDiario(jobRecorrenciasList)
    }
  }, [])

  useEffect(() => {
    const tempVar = listDiario.filter(
      (item) => item.hrRecorrencia !== '' && item.hrRecorrencia !== null
    )

    if (tempVar.length > 0) {
      listDiario.map((horario) => {
        const dateIsValid = new Date(horario.hrRecorrencia)
        if (!moment(dateIsValid).isValid()) {
          setErrorsJobs((old) => ({
            ...old,
            horarioError: {
              message: 'Há um horário inválido, verifique!'
            }
          }))
          setHasErrorJob((old) => ({
            ...old,
            horarioError: true
          }))
          return
        } else {
          setErrorsJobs((old) => ({
            ...old,
            horarioError: null
          }))
          setHasErrorJob((old) => ({
            ...old,
            horarioError: false
          }))
        }
      })
    } else {
      setErrorsJobs((old) => ({
        ...old,
        horarioError: {
          message: 'Ao menos um horário deve ser informado'
        }
      }))
      setHasErrorJob((old) => ({
        ...old,
        horarioError: true
      }))
    }
  }, [listDiario])

  return (
    <Col>
      <Row justifyContent="start">
        <Col>
          <SelectForm
            defaultValue={periodicidade}
            control={control}
            listOptions={listOptions}
            label="Tipo"
            width="160px"
            formValue="tipo"
          />
        </Col>
        <Col marginLeft={SPACING.spacing15}>
          {listDiario.map((diario, index) => (
            <Col key={index} marginBottom={SPACING.spacing10}>
              <Row alignItems="center" justifyContent="start">
                <TimePicker
                  allowTyping
                  marginRight={SPACING.spacing20}
                  label="Horário"
                  customError={errorsJobs.horarioError}
                  value={
                    diario.hrRecorrencia
                      ? moment(diario.hrRecorrencia).toDate()
                      : null
                  }
                  onChange={(data) => handleTimePicker(data, index)}
                />

                {index === 0 ? (
                  <Button text="+" onClick={handleNewItem} />
                ) : (
                  <>
                    <Button
                      text="+"
                      onClick={handleNewItem}
                      marginRight={SPACING.spacing5}
                    />
                    <Button text="-" onClick={() => handleDelete(diario.id)} />
                  </>
                )}
              </Row>
            </Col>
          ))}
        </Col>
      </Row>
      <Row alignItems="center" justifyContent="end">
        <Button text="Limpar" onClick={handleClean} variantButton="text" />
      </Row>
    </Col>
  )
}

export default Diario
